import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';
import type { AuthUser } from '~/features/auth/types/auth.type';

/**
 * 현재 로그인한 사용자 정보 조회
 * @endpoint GET /auth/me
 */
export function getMeApi() {
  return axiosInstance.get<ApiResponse<AuthUser>>('/auth/me');
}
